import Header from '@/components/Header'
import Footer from '@/components/Footer'

export default function JoinOurTeam() {
  return (
    <>
      <Header currentPage="join-our-team" />

      {/* Page Header */}
      <section className="py-16 bg-gray-50 pt-24">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            JOIN OUR TEAM
          </h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            We're always looking for skilled tradespeople and construction professionals to join our growing team
          </p>
        </div>
      </section>

      {/* Job Description */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4 max-w-4xl">
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8 md:p-12">
            
            <h2 className="text-3xl font-bold text-gray-900 mb-8">JOIN OUR TEAM</h2>

            {/* Overview */}
            <div className="mb-10">
              <h3 className="text-2xl font-bold text-gray-900 mb-4 border-b-2 border-blue-600 pb-2">OVERVIEW</h3>
              <p className="text-gray-700 leading-relaxed mb-4">
                TAKT Construction Services Ltd. is passionate about providing high-quality service in all areas of our construction projects, from initial concept to final code of compliance. We incorporate highly motivated team members where overall quality and pride in the job are the key factors to providing exceptional service.
              </p>
              <p className="text-gray-700 leading-relaxed mb-4">
                Our services span both commercial and residential construction, including:
              </p>
              <ul className="list-disc list-inside text-gray-700 mb-4 space-y-2">
                <li>Precast concrete services</li>
                <li>Specialized steel design & fabrication</li>
                <li>Panelized building envelope installation</li>
                <li>Mass timber installation</li>
                <li>Architectural & specialty concrete formwork</li>
                <li>Hardscapes</li>
                <li>Consulting & project planning</li>
              </ul>
              <p className="text-gray-700 leading-relaxed">
                Our mission is to undertake commercial and residential construction projects throughout the Greater Vancouver Region. We are expanding our business, upskilling our staff, and providing a pathway to future success for the company, employees, and contractors.
              </p>
            </div>

            {/* Position Overview */}
            <div className="mb-10">
              <h3 className="text-2xl font-bold text-gray-900 mb-4 border-b-2 border-blue-600 pb-2">POSITION OVERVIEW</h3>
              <div className="space-y-3 text-gray-700">
                <p><span className="font-semibold">Position Types:</span> We welcome skilled tradespeople across all construction disciplines</p>
                <p><span className="font-semibold">Reporting Relationships:</span> Site Foreman or Operations Manager</p>
                <p><span className="font-semibold">Expected hours of work:</span> Standard hours are a minimum 8 hours per day on weekdays</p>
                <p className="text-sm text-gray-600 italic">However, the nature of construction work may require time outside of standard hours.</p>
                <p><span className="font-semibold">Expected Pay Rate:</span> Competitive and negotiable, dependent upon demonstrated ability, trade certification, and previous experience.</p>
              </div>
            </div>

            {/* Role */}
            <div className="mb-10">
              <h3 className="text-2xl font-bold text-gray-900 mb-4 border-b-2 border-blue-600 pb-2">ROLE</h3>
              <p className="text-gray-700 leading-relaxed">
                We seek skilled tradespeople who can undertake construction tasks assigned by the foreman in a positive, efficient, and productive manner with pride in workmanship and quality. Whether you specialize in concrete, steel, timber, or general construction, we value expertise, dedication, and a commitment to excellence.
              </p>
            </div>

            {/* Responsibilities */}
            <div className="mb-10">
              <h3 className="text-2xl font-bold text-gray-900 mb-4 border-b-2 border-blue-600 pb-2">RESPONSIBILITIES</h3>
              <p className="text-gray-700 mb-4">Key responsibilities for all team members include:</p>
              <ul className="list-disc list-inside text-gray-700 space-y-2">
                <li>Arrive to work on time and maintain consistent attendance</li>
                <li>Provide appropriate notice for time off requests</li>
                <li>Communicate promptly with supervisors regarding absences or schedule changes</li>
                <li>Carry out all work assignments as instructed by the foreman or supervisor</li>
                <li>Maintain and properly care for your tools and equipment</li>
                <li>Track your hours accurately using our time tracking system</li>
                <li>Maintain a safe work environment at all times, following all safety protocols</li>
                <li>Adhere to our company code of conduct and professional standards</li>
                <li>Strive to produce high-quality work within appropriate timeframes</li>
                <li>Work collaboratively with team members to achieve project goals</li>
                <li>Take pride in your work and contribute positively to the team environment</li>
              </ul>
            </div>

            {/* Key Performance Indicators */}
            <div className="mb-10">
              <h3 className="text-2xl font-bold text-gray-900 mb-4 border-b-2 border-blue-600 pb-2">KEY PERFORMANCE INDICATORS</h3>
              <p className="text-gray-700 mb-4">Key performance indicators will be largely assessed by 4 forms:</p>
              <ul className="list-disc list-inside text-gray-700 space-y-2 mb-4">
                <li>Projects & stages completed under time</li>
                <li>Quality of work</li>
                <li>Client feedback</li>
                <li>Peer & foreman appraisals</li>
              </ul>
              <p className="text-gray-700 text-sm">
                The client will be given a questionnaire to complete regarding the overall impression of our team. This will include punctuality, quality, motivation, site cleanliness, etiquette, etc.
              </p>
            </div>

            {/* Future Possibilities & Career Development */}
            <div className="mb-10">
              <h3 className="text-2xl font-bold text-gray-900 mb-4 border-b-2 border-blue-600 pb-2">FUTURE POSSIBILITIES & CAREER DEVELOPMENT</h3>
              
              <div className="mb-6">
                <h4 className="text-xl font-semibold text-gray-900 mb-3">PERSONAL DEVELOPMENT & TRAINING</h4>
                <p className="text-gray-700">Up skilling courses as required. Contact management for guidance and discussion in these areas.</p>
              </div>

              <div className="mb-6">
                <h4 className="text-xl font-semibold text-gray-900 mb-3">CAREER DEVELOPMENT</h4>
                <p className="text-gray-700">Our aim will be to help you develop in necessary areas to promote you to the role of a foreman.</p>
              </div>
            </div>

            {/* Personal Attributes & Qualifications */}
            <div className="mb-10">
              <h3 className="text-2xl font-bold text-gray-900 mb-4 border-b-2 border-blue-600 pb-2">PERSONAL ATTRIBUTES & QUALIFICATIONS</h3>
              
              <div className="mb-6">
                <h4 className="text-xl font-semibold text-gray-900 mb-3">ESSENTIAL:</h4>
                <ul className="list-disc list-inside text-gray-700 space-y-2">
                  <li>Extremely ambitious with the drive and commitment to succeed</li>
                  <li>Passionate and committed to contributing to excellence in the business</li>
                  <li>Highly motivated and focused</li>
                  <li>Able to delight customers by exceeding expectations</li>
                  <li>Attention to detail when required</li>
                  <li>Shows initiative and is solution focused</li>
                  <li>Well-presented and articulate</li>
                  <li>Strong work ethic and reliability</li>
                  <li>Ability to work effectively as part of a team</li>
                </ul>
              </div>

              <div>
                <h4 className="text-xl font-semibold text-gray-900 mb-3">DESIRABLE:</h4>
                <ul className="list-disc list-inside text-gray-700 space-y-2">
                  <li>Trade certification in your area of expertise (carpentry, concrete, steel fabrication, etc.)</li>
                  <li>Experience in commercial and/or residential construction</li>
                  <li>Familiarity with modern construction techniques and materials</li>
                  <li>Valid driver's license and reliable transportation</li>
                </ul>
              </div>
            </div>

            {/* Contact */}
            <div className="mt-12 pt-8 border-t border-gray-200">
              <p className="text-gray-700 mb-4">
                Interested in joining our team? Please contact us at:
              </p>
              <p className="text-gray-700">
                <a href="mailto:support@taktcon.com" className="text-blue-600 hover:text-blue-800 font-medium">
                  support@taktcon.com
                </a>
              </p>
              <p className="text-gray-700 mt-2">
                <a href="tel:+16048428258" className="text-blue-600 hover:text-blue-800 font-medium">
                  (604) 842-8258
                </a>
              </p>
            </div>

          </div>
        </div>
      </section>

      <Footer />
    </>
  )
}

